import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Lightweight safeguard so libraries that expect a Node-like `process.env`
// in the browser don't crash when `process` is missing.
if (typeof window !== 'undefined') {
  window.process = window.process || {};
  window.process.env = window.process.env || { NODE_ENV: 'development' };
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
